import actions from "./actions";

const initState = {
  idToken: null,
  loading: false,
  user: null,
  isLoggedIn: false,
  sendingInfo: false,
  sendingRequest: false,
  email: "",
  errorMessage: "",
  successMessage: "",
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        isLoggedIn: false,
        errorMessage: "",
      };
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        idToken: action.token,
        user: action.user,
        loading: false,
        isLoggedIn: true,
      };
    case actions.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        isLoggedIn: false,
        errorMessage: action.message,
      };
    case actions.LOGOUT:
      return initState;
    case actions.USER_SIGN_UP:
      return {
        ...state,
        sendingInfo: true,
      };
    case actions.SIGN_UP_SUCCESS:
      return {
        ...state,
        sendingInfo: false,
        email: action.user.email,
      };
    case actions.FORGOT_PASSWORD:
      return {
        ...state,
        sendingRequest: true,
        errorMessage: "",
      };
    case actions.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        sendingRequest: false,
        successMessage: action.message,
      };
    case actions.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        sendingRequest: false,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}
